import { cachedFetch } from './api';
import { getFetchMeta } from './fetchWithCache';
import { BYBIT, fetchLinearTickers, tickersMeta } from './bybit';

const BINANCE_BTC_PREMIUM = 'https://fapi.binance.com/fapi/v1/premiumIndex?symbol=BTCUSDT';
const BYBIT_BTC_LS = `${BYBIT}/market/account-ratio?category=linear&symbol=BTCUSDT&period=1h&limit=1`;

/* BTC funding (Bybit + Binance average, the same rule as the Funding and
   Derivatívák tabs) and the Bybit long/short account ratio, in the shape the
   Stratégiák tab expects. A missing source stays null, so the card can say
   "Adat nem elérhető" instead of a verdict. */
export async function fetchBtcDerivSnapshot() {
  const [tick, bin, ls] = await Promise.allSettled([
    fetchLinearTickers(),
    cachedFetch(BINANCE_BTC_PREMIUM, 5 * 60 * 1000),
    cachedFetch(BYBIT_BTC_LS, 5 * 60 * 1000),
  ]);

  const bybitRate = tick.status === 'fulfilled' ? parseFloat(tick.value?.BTCUSDT?.fundingRate) : NaN;
  const binRate   = bin.status === 'fulfilled' ? parseFloat(bin.value?.lastFundingRate) : NaN;
  const rates = [bybitRate, binRate].filter(Number.isFinite);
  const avgRate = rates.length ? rates.reduce((s, v) => s + v, 0) / rates.length : null;

  let ratio = null;
  if (ls.status === 'fulfilled') {
    const d = ls.value?.result?.list?.[0];
    const buy = parseFloat(d?.buyRatio), sell = parseFloat(d?.sellRatio);
    if (Number.isFinite(buy) && Number.isFinite(sell) && sell > 0) ratio = buy / sell;
  }

  const metas = [tickersMeta(), getFetchMeta(BINANCE_BTC_PREMIUM), getFetchMeta(BYBIT_BTC_LS)].filter(m => m?.at);
  const meta = metas.length
    ? { at: Math.min(...metas.map(m => m.at)), stale: metas.some(m => m.stale) }
    : null;

  return {
    fundingData: avgRate != null ? { BTC: { avgRate } } : null,
    lsData: ratio != null ? { BTCUSDT: { ratio } } : null,
    meta,
  };
}
